import { metrics } from '@atlassian/browser-metrics/factory';
import type { Metric } from '@atlassian/browser-metrics/metric';

export const deadAirMetrics = {
	createDeadAirIntervalMetrics: (): Metric => {
		return metrics.interaction({
			key: 'ai-mate.dead-air-interval',
		});
	},
	createDeadAirMaxMetrics: (): Metric => {
		return metrics.interaction({
			key: 'ai-mate.dead-air-max',
		});
	},
};
